import React, { useState, useEffect } from "react";
import background from "modules/images/background.jpg";
import head from "modules/images/head.png";
import {
  PicBox,
  HeadBox,
  Box,
  TextBox,
  Circle,
  PicNews,
  CarouselCustom,
  RowCustom,
} from "./styled";
import logo from "modules/TopicNav/images/logo.svg";
import DetailText from "modules/DetailText";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import MainTopicTextBlue from "modules/MainTopicBlue";
import NewsChamber from "modules/NewsChamber";
import Mediaquery from "react-responsive";
import axios from "axios";
import { API_IP, CONFIG } from '../../constant/constant'
import { useTranslation } from "react-i18next";
import NavB from "modules/NavB";
import Footer from "modules/Footer";
const AboutPage = () => {
  const [about, setabout] = useState([]);
  const [aboutbanner, setaboutbanner] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      axios
      .get(API_IP + "/About", CONFIG)
      .then(function (response) {
        setabout(response.data);
      })
      .catch(function (error) {
      })

      axios
      .get(API_IP + "/About/banner", CONFIG)
      .then(function (response) {
        setaboutbanner(response.data);
      })
      .catch(function (error) {
      })
    };
    fetchData();
  }, []);

  var array_aboutbanner = []
  var item = []
  for(var i = 0 ; i< aboutbanner.length;i++){
    if(item.length < 7){
      item.push(aboutbanner[i])
    }else{
      item.push(aboutbanner[i])
      var data_temp = {
        data_array:item
      }
      array_aboutbanner.push(data_temp)
      item = []
    }
  }
  if(item.length > 0){
    var data_temp = {
      data_array:item
    }
    array_aboutbanner.push(data_temp)
  }
  const { t,i18n } = useTranslation();
  if(about.length > 0){
    var description_one = ''
    var description_two = ''
    var description_three = ''
    var title = ''
    if(i18n.language == 'en'){
      description_one = about[0].description_one_en
      description_two = about[0].description_two_en
      description_three = about[0].description_three_en
      title = about[0].title_en
    }else if(i18n.language == 'th'){
      description_one = about[0].description_one_th
      description_two = about[0].description_two_th
      description_three = about[0].description_three_th
      title = about[0].title_th
    }else if(i18n.language == 'ch'){
      description_one = about[0].description_one_cn
      description_two = about[0].description_two_cn
      description_three = about[0].description_three_cn
      title = about[0].title_cn
    }
  }
  return (
    <div>
      <NavB />
      <Box>
        <PicBox src={background} alt="background" />
        <TextBox>
          <Container>
            <div style={{ textAlign: "center" }}>
              <Circle src={logo} alt="logo" />
              <div style={{ fontWeight: "bold" }}>หอการค้าไทย - จีน</div>
              <div style={{ fontFamily: "cinzel" }}>
                THAI - CHINESE CHAMBER OF COMMERCE
              </div>
            </div>
          </Container>
        </TextBox>
      </Box>
      <HeadBox src={head} alt="headBackground" />
      <Container style={{marginTop:-120}}>
        <MainTopicTextBlue state={i18n.language} name={t('home.about')} />
      </Container>
      <Container>
        <DetailText 
          state={i18n.language}
          name={t('about.History_title')}
        />
        {about.length > 0 &&<Row>
          <Col md={5}>
            <PicNews src={about[0].url_img_one} alt="DetailPic" />
          </Col>
          <Col md={{ span: 7 }} dangerouslySetInnerHTML={{__html: description_one}}/>
          <Col md={{ span: 8 }} dangerouslySetInnerHTML={{__html: description_two}}/>

          <Col md={4}>
            <PicNews src={about[0].url_img_two} alt="DetailPic" />
          </Col>
          <Col dangerouslySetInnerHTML={{__html: description_three}}/>
        </Row>}
      </Container>
      {/* <Container>
        <DetailText
          state={'en'}
          name={t('about.chamber_of_commerce_network')}
        />
      </Container>

      <Mediaquery minWidth={768}>
        <Container>
          <CarouselCustom>
            {
              array_aboutbanner.map((item, index)=>{
                var item1 = item.data_array
                return(
                  <Carousel.Item key={index}>
                    <RowCustom md={4}>
                      {
                        item1.map((item2, index)=>{
                          return(
                            <Col xs={12}>
                              <NewsChamber data={item2}/>
                            </Col>
                          )
                        })
                      }
                    </RowCustom>
                  </Carousel.Item>
                )
              })
            }
            
            
          </CarouselCustom>
          
        </Container>
      </Mediaquery> */}
      <Footer />
    </div>
  );
};

export default AboutPage;
